<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-amzPriceControlParams',
  components: { PageTable },
}
</script>
